<template>
  <footer class="border-top fixed-bottom">
    <div class="bg">
             <p class="text-center">V 2.0 &copy;copyright | niangbalo </p> 
            <a href="https://www.linkedin.com/in/fatou-niang-43b7a719a" ><i class="bi bi-linkedin center" ></i></a>&nbsp;&nbsp;
            <a href="https://github.com/fatou267" ><i class="bi bi-github center" ></i></a>
    </div>
    </footer>
    <br><br><br>
</template>

<script>
export default {
    name: 'footerView'
}
</script>

<style scoped>
.center{
  color: #bd6513;
  font-size: 30px;
}
.bg{
    background-color: #000000 ;
    color: #bd6513 ;
}
</style>